module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-expand-shadow-bottom.66890e9b.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-expand-shadow-bottom.png
// module id = 3818
// module chunks = 11